module.exports = __webpack_public_path__ + "img/b018850.jpg";